$(document).ready(function () {
    const slider = $('.poster-slider__container');

    if (slider.length > 0) {
        slider.slick({
            slidesToShow: 3,
            appendArrows: $('.poster-slider__nav'),
            arrows: true,
            infinite: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 700,
                    settings: {
                        slidesToShow: 1,
                        centerMode: true,
                    }
                },
            ]
        });
    }
});
